import axios from 'axios'

const state = {
  onixFiles: [],
  archivedFiles: [],
  loading: false
}

const mutations = {
  UPDATE_ONIX_FILES (state, payload) {
    state.onixFiles = payload
  },
  UPDATE_ARCHIVED_FILES (state, payload) {
    state.archivedFiles = payload
  },
  UPDATE_LOADING (state, payload) {
    state.loading = payload
  }
}

const actions = {
  getOnixFiles ({ commit }) {
    axios
      .get(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/biblio/onix')
      .then((response) => {
        commit('UPDATE_ONIX_FILES', response.data)
      })
  },
  getArchivedFiles ({ commit }) {
    axios
      .get(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/biblio/onix/archive')
      .then((response) => {
        commit('UPDATE_ARCHIVED_FILES', response.data)
      })
  },
  async processOnixFile ({ commit, dispatch }, filename) {
    commit('UPDATE_LOADING', true)
    await axios
      .get(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/biblio/onix/' + filename + '/process')
    await dispatch('getOnixFiles')
    await dispatch('getArchivedFiles')
    commit('UPDATE_LOADING', false)
  },
  async archiveOnixFile ({ commit, dispatch }, filename) {
    commit('UPDATE_LOADING', true)
    await axios.delete(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/biblio/onix/' + filename)
    await dispatch('getOnixFiles')
    await dispatch('getArchivedFiles')
    commit('UPDATE_LOADING', false)
  },
  async unArchiveOnixFile ({ commit, dispatch }, filename) {
    commit('UPDATE_LOADING', true)
    await axios.delete(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/biblio/onix/archive/' + filename)
    await dispatch('getOnixFiles')
    await dispatch('getArchivedFiles')
    await commit('UPDATE_LOADING', false)
  }
}

const getters = {
  onixFiles: state => state.onixFiles,
  archivedFiles: state => state.archivedFiles,
  loading: state => state.loading
}

const biblioModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default biblioModule
